import React, {useState} from 'react';
import { Modal as DesignModal, Input, Icon } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import Element from "@whalecloud/page-builder-core/components/Element";
import { popEditRegExp } from '@utils/util';

const Participant = props => {
  const { element, elementStyle } = props;
  const { formSettings, formItemSettings, elements, settings, className = '' } = element.data;
  const { defaultValue = [] } = formItemSettings;
  const { rules = [] } = formSettings;
  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => popEditRegExp(rule, value, defaultValue, rules[0]) }]
  }

  const [visible, setVisible] = useState('false');

  const handleOk = () => {
    setVisible('false');
  }

  const onOpen = () => {
    setVisible('true');
  }

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle
      }}
      {...formSettings}
      {...ruleProps}
    >
      <Input suffix={<Icon type="select" onClick={onOpen} />} onClick={onOpen} readOnly />
      <DesignModal
        visible={visible}
        getContainer= {document.getElementById('page-build-editor-content')}
        {...formItemSettings} 
        onOk={() => handleOk()}
      >
        <Element id={elements[0].id} />
      </DesignModal>
    </FormItem>
  );
};

export default Participant;
